<template>
  <!-- eslint-disable -->
  <div class="mobile-application">
    <section class="section-am-bg">
      <div class="heading-section-container app-container-wrapper">
        <div class="heading-text">
          <h2 class="heading-text-main-title">Aplikacja Librus</h2>
          <h2 class="heading-text-subtitle">wiesz więcej</h2>
        </div>
        <a
          href="https://rodzina.librus.pl/"
          class="header-use-in-browser-button"
          target="_blank"
          >Korzystaj w przeglądarce</a
        >
        <div class="header-buttons-container">
          <a
            href="https://play.google.com/store/apps/details?id=pl.librus.synergiaDru2"
            rel="noopener noreferrer"
            target="_blank"
            class="header-button"
          >
            Pobierz z Google Play
          </a>
          <a
            href="https://itunes.apple.com/pl/app/synergia/id1122457592?mt=8&v0=WWW-EUPL-ITSTOP100-FREEAPPS&l=pl&ign-mpt=uo%3D4"
            rel="noopener noreferrer"
            target="_blank"
            class="header-button"
          >
            Pobierz z App Store
          </a>
          <a
            href="https://appgallery.huawei.com/#/app/C103117931"
            rel="noopener noreferrer"
            target="_blank"
            class="header-button"
          >
            Odkryj w App Gallery
          </a>
        </div>
      </div>
    </section>
    <section class="section-white">
      <div class="app-container-wrapper">
        <div>
          <div class="col-12 text-center mt-3">
            <div class="use-case-title-wrapper">
              <h2 class="use-case-title">Wygodne przeglądanie</h2>
              <h2 class="use-case-title">informacji o uczniu</h2>
            </div>
            <h3 class="use-case-subtitle">w wersji mobilnej i na komputerze</h3>
          </div>
          <div class="text-center mt-5">
            <img
              src="../assets/images/grafika_zakladka_aplikacja_librus.png"
              class="internal-image"
            />
          </div>
        </div>
        <div class="row mt-5 benefits-wrapper">
          <div class="text-center trophy-icon">
            <div class="icon-wrap">
              <TrophyIcon />
            </div>
            <h4 class="subtitle3">Plan SMART DODATKI - najlepszy wybór</h4>
            <p class="mt-4 body3">
              Jedna opłata, do 5 kont dzieci, brak reklam, poradniki wideo i
              pełna wygoda &mdash; nowość w aplikacji Librus
            </p>
          </div>
          <div class="text-center mt-3 calendar">
            <div class="icon-wrap">
              <CalendarIcon />
            </div>
            <h4 class="subtitle3">Wygodny dostęp do informacji</h4>
            <p class="mt-4 body3">
              Oceny, nieobecności, plan lekcji – najważniejsze informacje z
              dziennika elektronicznego na jedno kliknięcie
            </p>
          </div>
          <div class="text-center mt-3">
            <div class="icon-wrap">
              <MessageIcon size="large" />
            </div>
            <h4 class="subtitle3">Szybka komunikacja ze szkołą</h4>
            <p class="mt-4 body3">
              Wiadomości, Ogłoszenia, Uwagi o uczniu pozwalają sprawnie
              komunikować się z nauczycielami
            </p>
          </div>
          <div class="text-center mt-3">
            <div class="icon-wrap">
              <LibrusGoIcon size="large" />
            </div>
            <h4 class="subtitle3">Zajęcia pozalekcyjne Twojego dziecka</h4>
            <p class="mt-4 body3">
              Przypomnienia o płatnościach, wygodne przelewy on-line czy grafik
              zajęć – dostępne również w aplikacji, gdy szkoła korzysta z
              LibrusGO
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section-plans-bg">
      <div class="col-12 text-center mb-5 app-container-wrapper">
        <h2 class="heading3 text-white text-uppercase">
          KORZYSTAJ Z DODATKOWYCH FUNKCJI
        </h2>
      </div>
      <div
        class="row justify-content-center plans-wrapper app-container-wrapper"
      >
        <div class="plan-card plan-card--light">
          <div class="plan-card__icons">
            <SinglePersonIcon size="medium" />
            <SinglePersonIcon size="medium" />
            <SinglePersonIcon size="medium" />
            <SinglePersonIcon size="medium" />
            <SinglePersonIcon size="medium" />
          </div>
          <h3 class="plan-card__title">Plan SMART DODATKI</h3>
          <p class="plan-card__description">
            Wybierz mądrze – wyłącz reklamy i otrzymuj tylko informacje ze
            szkoły. Dodaj do 5 kont dzieci w wygodnej miesięcznej opłacie.
            Anuluj subskrypcję, kiedy chcesz.
          </p>
          <div class="plan-card__payment d-flex flex-column align-items-center">
            <span class="payment-badge">Do 5 kont dzieci </span>
            <span class="payment-badge">Subskrypcja miesięczna</span>
            <span class="payment-badge">Brak reklam na koncie kupującego</span>
          </div>
          <a
            href="#smart-plan-container"
            class="btn btn-outline-light plan-card__btn"
            style="background-color: #f9dc47; color: #4a4a4a"
            >WIĘCEJ</a
          >
        </div>
        <div class="plan-card plan-card--dark">
          <div class="plan-card__icons mobile-addons-title">
            <SinglePersonIcon size="medium" color="white" />
          </div>
          <h3 class="plan-card__title mobile-addons-title">
            Warianty Mobilnych dodatków
          </h3>
          <p class="plan-card__description mobile-addons-description">
            Zapłać z góry za cały rok szkolny i korzystaj z dodatkowych funkcji
            aplikacji Librus. Otrzymuj oferty partnerów i najważniejsze
            informacje ze szkoły prosto na smartfona.
          </p>
          <div class="plan-card__payment d-flex flex-column align-items-center">
            <span class="payment-badge payment-mobile-app-badge">
              1 konto dziecka
            </span>
            <span class="payment-badge payment-mobile-app-badge">
              Płatność roczna z góry
            </span>
            <span class="payment-badge payment-mobile-app-badge"
              >Reklamy wyświetlane na Osi czasu
            </span>
          </div>
          <a
            href="#mobile-variants"
            class="btn btn-outline-light plan-card__btn"
          >
            WIĘCEJ
          </a>
        </div>
      </div>
    </section>
    <section
      style="margin-top: 72px; margin-bottom: 72px"
      class="app-container-wrapper"
    >
      <div
        class="librus-go-wrapper app-container-wrapper"
        style="max-width: 1230px; margin: 0 auto"
      >
        <div class="librus-go-logo">
          <img src="../assets/images/Librus-Go.svg" alt="Logo Librus Go" />
        </div>
        <div class="px-md-0 pt-md-0 pt-4">
          <h2 class="librus-go-header">
            Zajęcia pozalekcyjne Twojego dziecka – z aplikacją pod kontrolą!
          </h2>
          <p class="librus-go-paragraph mb-4">
            W aplikacji Librus znajdziesz najważniejsze informacje o zajęciach
            pozalekcyjnych swojego dziecka. Wystarczy, że szkoła korzysta z
            systemu LibrusGO!
          </p>
          <div class="features-list d-flex mb-4">
            <div class="features-list d-flex flex-column mb-4 px-2">
              <div class="feature-item d-flex mb-3">
                <div class="feature-icon me-3">
                  <ArrowBlue />
                </div>
                <span class="feature-text"
                  >Wygodna komunikacja z sekretariatem szkoły i prowadzącymi
                  zajęcia</span
                >
              </div>
              <div class="feature-item d-flex align-items-start mb-3">
                <div class="feature-icon me-3">
                  <ArrowOrange />
                </div>
                <span class="feature-text"
                  >Przejrzysty grafik zajęć zawsze pod ręką</span
                >
              </div>
            </div>
            <div class="features-list d-flex flex-column mb-4 px-2">
              <div class="feature-item d-flex align-items-start mb-3">
                <div class="feature-icon me-3">
                  <ArrowOrange />
                </div>
                <span class="feature-text">
                  Powiadomienia o zbliżających się płatnościach – dla Twojej
                  wygody!
                </span>
              </div>
              <div class="feature-item d-flex align-items-start mb-3">
                <div class="feature-icon me-3">
                  <ArrowBlue />
                </div>
                <span class="feature-text"
                  >Szybkie przelewy online – bez myślenia o odliczonej
                  gotówce</span
                >
              </div>
            </div>
          </div>
          <div class="availability-section">
            <p class="availability-text">Dostępne w:</p>
            <div class="availability-tags">
              <span class="availability-tag">Planie SMART DODATKI</span>
              <span class="availability-tag"
                >Wariantach Mobilnych dodatków</span
              >
              <span class="availability-tag">Wariancie Podstawowym</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="smart-addons-mobile-plan-section">
      <div
        class="smart-addons-mobile-plan-container app-container-wrapper"
        id="smart-plan-container"
      >
        <div class="smart-addons-mobile-plan-image">
          <img src="../assets/images/foto/aplikacja_mobilna_banner.png" />
        </div>
        <div class="smart-addons-mobile-plan-title-mobile">
          <div class="smart-addons-mobile-plan-badge">NAJLEPSZY WYBÓR</div>
          <h2 class="smart-addons-mobile-plan-exact-title">
            Plan SMART DODATKI
          </h2>
          <div class="smart-addons-mobile-plan-price">
            14,99 zł / miesiąc<sup>1</sup>
          </div>
        </div>
        <div class="smart-addons-mobile-plan-content">
          <div class="smart-addons-mobile-plan-title-desktop">
            <div class="smart-addons-mobile-plan-badge">NAJLEPSZY WYBÓR</div>
            <h2 class="smart-addons-mobile-plan-exact-title">
              Plan SMART DODATKI
            </h2>
            <div class="smart-addons-mobile-plan-price">
              14,99 zł / miesiąc<sup>1</sup>
            </div>
          </div>
          <p class="smart-addons-mobile-plan-description">
            Plan SMART DODATKI to wszystkie funkcje aplikacji i brak reklam na
            koncie kupującego<sup>2</sup>. To wygodna, miesięczna płatność z
            możliwością rezygnacji w każdej chwili, ekskluzywne funkcje dostępne
            tylko w tym planie oraz możliwość podpięcia do 5 kont dzieci bez
            żadnych dodatkowych opłat!
          </p>
          <div class="smart-addons-mobile-plan-buttons">
            <a
              href="https://play.google.com/store/apps/details?id=pl.librus.synergiaDru2"
              class="smart-addons-mobile-plan-button"
              target="_blank"
              >KUP W GOOGLE PLAY</a
            >
            <a
              href="https://apps.apple.com/pl/app/librus/id1122457592?l=pl&ign-mpt=uo%3D4&v0=WWW-EUPL-ITSTOP100-FREEAPPS"
              class="smart-addons-mobile-plan-button"
              target="_blank"
              >KUP W APP STORE</a
            >
            <a
              href="https://appgallery.huawei.com/#/app/C103117931"
              class="smart-addons-mobile-plan-button"
              target="_blank"
              >KUP W APP GALLERY</a
            >
          </div>
          <div class="smart-addons-mobile-divider"></div>
          <div class="smart-addons-mobile-features">
            <div class="smart-addons-mobile-feature">
              <h4 class="smart-addons-mobile-feature-title">
                <span class="smart-addons-mobile-feature-title-highlight"
                  >Brak</span
                >
                reklam
              </h4>
              <p class="smart-addons-mobile-feature-text">
                Wyłącz reklamy i uporządkuj swoją oś czasu! Otrzymuj tylko to,
                co naprawdę ważne – informacje ze szkoły Twojego
                dziecka<sup>2</sup>.
              </p>
            </div>
            <div class="smart-addons-mobile-feature">
              <h4 class="smart-addons-mobile-feature-title">
                Do
                <span class="smart-addons-mobile-feature-title-highlight"
                  >5 kont</span
                >
                dzieci
              </h4>
              <p class="smart-addons-mobile-feature-text">
                Zapłać raz i aktywuj dodatkowe funkcje nawet na 5 kontach
                dzieci. Uczniowie otrzymają dostęp do wszystkich udogodnień
                zawartych w Mobilnych dodatkach PLUS.
              </p>
            </div>
            <div class="smart-addons-mobile-feature">
              <h4 class="smart-addons-mobile-feature-title">
                Wygodna
                <span class="smart-addons-mobile-feature-title-highlight"
                  >miesięczna</span
                >
                opłata
              </h4>
              <p class="smart-addons-mobile-feature-text">
                Postaw na wygodę i jedną miesięczną opłatę za całą rodzinę.
                Jeśli zmienisz zdanie – subskrypcję anulujesz w dowolnym
                momencie<sup>3</sup>.
              </p>
            </div>
          </div>
          <div class="smart-addons-mobile-divider"></div>
          <div class="smart-addons-mobile-functionality-section">
            <h3 class="smart-addons-mobile-functionality-title">
              Poznaj pełną funkcjonalność
            </h3>
            <div class="smart-addons-mobile-functionality-list">
              <div class="row">
                <div class="col-md-6">
                  <ul class="feature-list">
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-text-highlight feature-label"
                        >Brak reklam</span
                      >
                      <div class="feature-icons">
                        <description-tooltip
                          content="Zadbaj o porządek na swojej Osi czasu! Po
                                aktywacji Planu SMART DODATKI możesz zarządzać
                                wyświetlaniem reklam: oferty partnerów, artykuły
                                merytoryczne czy tylko informacje ze szkoły – Ty
                                decydujesz, co zobaczysz. Opcja braku reklam
                                dostępna na Koncie LIBRUS kupującego, na
                                pozostałych kontach dostępne będą funkcje
                                Mobilnych dodatków PLUS<sup>2</sup>."
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-text-highlight feature-label"
                        >Poradniki wideo</span
                      >
                      <div class="feature-icons">
                        <description-tooltip
                          content="Oglądaj poradniki wideo z konkretnymi wskazówkami, jak
                          wspierać swoje dziecko na co dzień i reagować na
                          trudne sytuacje. Dla rodziców młodszych i starszych
                          dzieci – pełne praktycznych porad, które naprawdę
                          warto wdrożyć. Idealne do kawy albo na krótką przerwę
                          w pracy. Poradniki wideo dostępne na Koncie LIBRUS kupującego."
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label"
                        >Aktualizacja danych na bieżąco
                      </span>
                    </li>
                    <li><span class="feature-dot"></span>Oceny</li>
                    <li><span class="feature-dot"></span>Szczęśliwy numerek</li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Spotkanie/lekcja online</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Spotkanie/lekcja online',
                            )
                          "
                        />
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label"
                        >Zaplanowane i zrealizowane lekcje</span
                      >
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Zaplanowane i zrealizowane lekcje',
                            )
                          "
                        />
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Nieobecności i uwagi</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Nieobecności i uwagi',
                            )
                          "
                        />
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Ogłoszenia</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName('Ogłoszenia')
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Multikonto</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName('Multikonto')
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Oś czasu</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName('Oś czasu')
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Plan lekcji i Terminarz</span>
                      <div class="feature-icons">
                        <description-tooltip
                          content="
W jednym wspólnym widoku prezentują przedmioty i wydarzenia zaplanowane na konkretna datę. Znajdziesz tam także informacje o lekcjach online oraz bezpośredni link do każdego zaplanowanego spotkania. Łatwiej zaplanujesz dzień, dodając do Terminarza własne wydarzenia, np. dodatkowe zajęcia dziecka. <br><br> W oddziałach przedszkolnych moduł prezentuje ramowy plan dnia.
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Zdjęcia do legitymacji</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Zdjęcia do legitymacji',
                            )
                          "
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <ul class="feature-list">
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Wiadomości</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName('Wiadomości')
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label"
                        >Zadania domowe i projekty</span
                      >
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Zadania domowe i projekty',
                            )
                          "
                        />
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">e-Usprawiedliwienia</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'e-Usprawiedliwienia',
                            )
                          "
                        />
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Biurko</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName('Biurko')
                          "
                        />
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label"
                        >Natychmiastowe powiadomienia</span
                      >
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Natychmiastowe powiadomienia',
                            )
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">LIBRUS Spokojna noc</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'LIBRUS Spokojna noc',
                            )
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Personalizacja</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName('Personalizacja')
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Pobieranie plików</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Pobieranie plików',
                            )
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Przypinanie wiadomości</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Przypinanie wiadomości',
                            )
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label" style="flex: 0 0 auto"
                        >Tygodniowy widok Planu lekcji i Terminarza</span
                      >
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Tygodniowy widok Planu lekcji i&nbsp;Terminarza',
                            )
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Przypomnienia</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName('Przypomnienia')
                          "
                        />
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label">Panel Moje Cele</span>
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Panel Moje Cele',
                            )
                          "
                        />
                      </div>
                    </li>
                    <li>
                      <span class="feature-dot"></span>
                      <span class="feature-label"
                        >Własne zdjęcie profilowe</span
                      >
                      <div class="feature-icons">
                        <description-tooltip
                          :content="
                            getFeatureDescriptionByFeatureName(
                              'Własne zdjęcie profilowe',
                            )
                          "
                        />
                        <VTooltip
                          :triggers="['hover', 'click']"
                          :popper-triggers="['hover', 'click']"
                          :auto-hide="true"
                        >
                          <KindergartenIcon color="grey" size="medium" />
                          <template #popper>
                            <div style="max-width: 290px">
                              <p style="color: white; margin-bottom: 0">
                                Dostępne w oddziałach przedszkolnych
                              </p>
                            </div>
                          </template>
                        </VTooltip>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="smart-addons-mobile-divider disclaimer-separator"></div>
          <div class="smart-addons-mobile-disclaimer">
            1) W ramach jednej opłaty do subskrypcji można podpiąć nawet 5 kont
            dzieci (na tych kontach dostępne będą funkcje Mobilnych dodatków
            PLUS). Więcej informacji znajduje się w
            <a
              href="https://portal.librus.pl/dokumenty/regulamin-portalu-rodzina-1-5"
              target="_blank"
              >Regulaminie świadczenia usługi</a
            >
            oraz w dziale <a href="/pomoc" target="_blank">Pomoc</a>. <br />
            Cena obowiązuje od 1 września 2026 r.
            <br />
            2) Opcja wyłączenia reklam dostępna na Koncie LIBRUS kupującego, na
            pozostałych kontach dostępne będą funkcje Mobilnych dodatków PLUS.
            Kupujący może samodzielnie zarządzać wyświetlaniem reklam i
            decydować, jakie materiały chce otrzymywać np. oferty partnerów,
            artykuły merytoryczne czy tylko informacje ze szkoły.
            <br />
            3) Plan SMART DODATKI działa przez cały okres aktywnej (opłaconej)
            subskrypcji miesięcznej. Subskrypcję można anulować w dowolnym
            momencie (będzie aktywna do końca bieżącego, opłaconego miesiąca) i
            wykupić ją ponownie.
            <br />
            Opis funkcji dotyczy wersji aplikacji na rok szkolny 2026/27
            (obowiązującej od 1 września 2026 r.).
          </div>
        </div>
      </div>
    </section>
    <section class="mobile-variants-wrapper" id="mobile-variants">
      <div class="mobile-variants-container app-container-wrapper">
        <h3 class="mobile-variants-section-title">
          Wybierz wariant Mobilne dodatki
        </h3>
        <div class="mobile-variants-list">
          <div
            v-for="(item, index) in mobileAppVariants"
            :key="item.name"
            class="mobile-variant-item"
          >
            <div class="mobile-variant-item-header">
              <h6 class="mobile-variant-item-header-text">Wariant</h6>
              <h6
                class="mobile-variant-item-header-title"
                :class="{
                  orange: item.color === 'secondary',
                  blue: item.color === 'primary',
                }"
              >
                {{ item.name }}
              </h6>
              <h3 class="mobile-variant-item-header-price">
                <ShowPrice
                  :fetched-price="fetchedPrice"
                  :fetched-error="fetchedError"
                  :product-code="item.product_code"
                /><span
                  v-if="item.price_asterisk"
                  class="mobile-variant-item-header-price"
                  :class="{
                    orange: item.color === 'secondary',
                    blue: item.color === 'primary',
                  }"
                  ><sup>4</sup></span
                >
              </h3>
              <div
                class="mobile-variant-item-additional-info"
                v-if="index !== 2"
              >
                <p>Opłata z góry za rok szkolny</p>
                <p><SinglePersonIcon size="small" />1 konto dziecka</p>
              </div>
              <a
                target="_blank"
                :href="item.action_link"
                class="mobile-wariant-button-cta"
                :class="{
                  primary: item.color === 'primary',
                  outlined: item.action_variant === 'outlined',
                }"
                >{{ item.action_name }}</a
              >
            </div>
            <ul class="mobile-variants-features-list">
              <li
                v-for="feature in item.features"
                :key="feature.name"
                class="mobile-variants-features-list-item"
                :class="{
                  orange: index === 0,
                }"
              >
                <span>
                  <CheckIcon size="small" :color="item.color" />
                </span>
                <div style="display: flex">
                  <!-- eslint-disable vue/no-v-html -->
                  <span
                    v-html="feature.name"
                    style="flex: 0 0 auto"
                    :class="{
                      longTextInFeature: checkIfHasLongText(feature.name) > 300,
                    }"
                  />
                  <!--eslint-enable-->
                  <div
                    v-if="feature.tooltip"
                    class="md-variant__tooltip"
                    style="display: flex"
                  >
                    <div class="d-md-block d-none">
                      <VTooltip>
                        <HelpIcon color="light-grey" data-html="true" />
                        <template #popper>
                          <div
                            style="max-width: 240px"
                            v-html="feature.tooltip"
                          />
                        </template>
                      </VTooltip>
                    </div>
                    <div class="d-md-none d-block">
                      <VDropdown>
                        <HelpIcon color="light-grey" data-html="true" />
                        <template #popper>
                          <div
                            style="
                              max-width: 240px;
                              background: rgba(0, 0, 0, 0.8);
                              color: #ffffff;
                              padding: 6px;
                              border-radius: 4px;
                            "
                            v-html="feature.tooltip"
                          />
                        </template>
                      </VDropdown>
                    </div>
                  </div>
                  <div class="d-md-block d-none">
                    <VTooltip
                      v-if="Boolean(feature.kindergarten_features)"
                      style="margin-left: 0px"
                    >
                      <KindergartenIcon
                        color="grey"
                        size="medium"
                        data-html="true"
                        style="margin-left: 5px"
                      />
                      <template #popper>
                        <div style="max-width: 290px">
                          <p style="color: white; margin-bottom: 0">
                            Dostępne w oddziałach przedszkolnych
                          </p>
                        </div>
                      </template>
                    </VTooltip>
                  </div>
                  <div class="d-md-none d-block">
                    <VDropdown v-if="Boolean(feature.kindergarten_features)">
                      <KindergartenIcon
                        color="grey"
                        size="medium"
                        data-html="true"
                        style="margin-left: 5px"
                      />
                      <template #popper>
                        <div
                          style="
                            max-width: 240px;
                            background: rgba(0, 0, 0, 0.8);
                            color: #ffffff;
                            padding: 6px;
                            border-radius: 4px;
                          "
                        >
                          Dostępne w oddziałach przedszkolnych
                        </div>
                      </template>
                    </VDropdown>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <p class="mobile-variants-additional-info-text app-container-wrapper">
            4) Podana cena za wariant dotyczy okresu liczonego od dnia aktywacji
            usługi do końca bieżącego roku szkolnego - dnia 30 czerwca
            (następującego po aktywacji usługi). W okresie letnich wakacji
            (lipiec i sierpień), w miarę możliwości technicznych, warianty
            Mobilne dodatki oraz Mobilne dodatki PLUS będą również aktywne bez
            dodatkowych opłat. W ramach jednej opłaty warianty Mobilne dodatki
            lub Mobilne dodatki PLUS aktywowane są dla konta jednego ucznia oraz
            kont jego rodziców. Więcej informacji znajduje się w
            <a
              href="https://portal.librus.pl/dokumenty/regulamin-portalu-rodzina-1-5"
              target="_blank"
              >Regulaminie świadczenia usługi</a
            >
            oraz w dziale <a href="/pomoc" target="_blank">Pomoc</a>.<br />
            Ceny obowiązują od 1 września 2026 r.<br />
            Ceny w sklepach z aplikacjami mobilnymi na poszczególnych
            platformach oraz sklepie na portalu Librus Rodzina mogą się różnić.
            <br />
            5) Funkcjonalność dostępna w wariancie Mobilne dodatki lub Mobilne
            dodatki PLUS. <br />Opis funkcji dotyczy wersji aplikacji na rok
            szkolny 2026/27 (obowiązującej od 1 września 2026 r.).
          </p>
        </div>
      </div>
    </section>
    <section id="smart-plan-section">
      <div class="smart-plan-container app-container-wrapper">
        <div class="smart-plan-heading-item">
          <h2>WYBIERZ SPOSÓB ZAKUPU</h2>
        </div>
        <div class="smart-plan-intems-wrapper">
          <div class="smart-plan-item">
            <p class="smart-plan-title">PLAN SMART DODATKI</p>
            <p class="smart-plan-content">
              Przejdź do wybranego sklepu i aktywuj Plan SMART DODATKI w
              wygodnej subskrypcji miesięcznej
            </p>
            <div class="smart-plan-buttons-container">
              <a
                href="https://play.google.com/store/apps/details?id=pl.librus.synergiaDru2"
                target="_blank"
                >KUP W GOOGLE PLAY
              </a>
              <a
                href="https://apps.apple.com/pl/app/librus/id1122457592?l=pl&ign-mpt=uo%3D4&v0=WWW-EUPL-ITSTOP100-FREEAPPS"
                target="_blank"
                >KUP W APP STORE</a
              >
              <a
                href="https://appgallery.huawei.com/#/app/C103117931"
                target="_blank"
                >KUP W APP GALLERY</a
              >
            </div>
          </div>
          <div class="smart-plan-item">
            <p class="smart-plan-title">MOBILNE DODATKI</p>
            <p class="smart-plan-content">
              Zaloguj się na swoje Konto LIBRUS i kup Mobilne dodatki, Mobilne
              dodatki PLUS lub Rozszerzenie do Mobilnych dodatków PLUS
            </p>
            <a
              href="https://portal.librus.pl/rodzina/sklep/mobilne-dodatki/wybor"
              class="smart-plan-sign-in-button"
              target="_blank"
              >ZALOGUJ SIĘ NA KONTO LIBRUS
            </a>
          </div>
          <div class="smart-plan-item">
            <p class="smart-plan-title">VOUCHER</p>
            <p class="smart-plan-content">
              Wybierz voucher na Mobilne dodatki lub Mobilne dodatki PLUS dla
              dowolnego użytkownika aplikacji<sup>6</sup>. Kup bez zakładania
              Konta LIBRUS
            </p>
            <a
              href="https://portal.librus.pl/rodzina/sklep/mobilne-dodatki-voucher/wybor"
              class="smart-plan-voucher-button"
              target="_blank"
              >KUP VOUCHER
            </a>
          </div>
        </div>
        <div class="smart-plan-additional-info">
          <p>
            6) Voucher umożliwia aktywację Mobilnych dodatków lub Mobilnych
            dodatków PLUS w późniejszym czasie. Aby wykorzystać voucher,
            konieczne jest założenie bezpłatnego Konta LIBRUS. Więcej informacji
            na ten temat w
            <a
              href="https://portal.librus.pl/dokumenty/regulamin-portalu-rodzina-1-5"
              rel="noopener noreferrer"
              target="_blank"
              >Regulaminie</a
            >.
          </p>
        </div>
      </div>
    </section>
    <section id="odkryj-aplikacje" class="section-discover-app-bg">
      <div class="container">
        <div class="row mt-5">
          <div class="col-12 text-center">
            <h2 class="discover-app-label">Odkryj aplikację</h2>
          </div>
          <div class="col-12 text-center mt-3">
            <a
              href="https://rodzina.librus.pl/"
              class="btn btn-default btn-cta btn-cta--primary mt-3 text-uppercase custom-size"
              target="_blank"
              >Korzystaj w przeglądarce</a
            >
          </div>
          <div class="col-12 mt-2 text-center">
            <a
              href="https://play.google.com/store/apps/details?id=pl.librus.synergiaDru2"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src="../assets/images/icons/Google_play_black.svg"
                class="gp-img-btn"
              />
            </a>
            <a
              href="https://itunes.apple.com/pl/app/synergia/id1122457592?mt=8&v0=WWW-EUPL-ITSTOP100-FREEAPPS&l=pl&ign-mpt=uo%3D4"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src="../assets/images/icons/App_store_black.svg"
                class="as-img-btn"
              />
            </a>
            <a
              href="https://appgallery.huawei.com/#/app/C103117931"
              rel="noopener noreferrer"
              target="_blank"
            >
              <img
                src="../assets/images/icons/AppGallery_Huawei_black.svg"
                class="hu-img-btn"
              />
            </a>
          </div>
          <div class="col-12 mt-5">
            <p class="caption2 mb-0 text-white">
              Korzystanie z aplikacji Librus wymaga założenia Konta LIBRUS oraz
              jego powiązania z kontem w systemie Synergia.<br />
              Aplikacja Librus dostępna jest w 4 opcjach, które różnią się
              liczbą funkcji. Wariant podstawowy jest bezpłatny, warianty
              Mobilne dodatki i Mobilne dodatki PLUS oraz Plan SMART DODATKI są
              płatne. Działanie poszczególnych funkcji aplikacji Librus
              (niezależnie od wariantu) może być uzależnione od ich
              wykorzystania przez szkołę. Jeśli szkoła nie korzysta z danego
              modułu czy funkcji w systemie Synergia, nie będą one dostępne
              również w aplikacji Librus, dopóki szkoła ich nie włączy. Usługa
              Natychmiastowe powiadomienia w aplikacji mobilnej Librus jest
              świadczona na wybranych platformach mobilnych zgodnie z zapisami
              <a
                href="/regulaminy"
                rel="noopener noreferrer"
                target="_blank"
                class="rules-link"
                >Regulaminu świadczenia usługi</a
              >.<br />
              Aplikacja Librus dla oddziałów przedszkolnych ma inny zakres
              funkcji niż wersja dla szkół. Szczegółowy zakres modułów i funkcji
              dostępny w aplikacji dla szkół i oddziałów przedszkolnych znajduje
              się powyżej.<br />Wyświetlanie informacji z systemu LibrusGO
              możliwe jest po aktywacji dostępu w tym systemie. Korzystanie z
              funkcji płatności on-line dostępne jest tylko w szkołach, które
              włączyły tę funkcję w systemie LibrusGO. <br />Część usług
              oferowanych w ramach Konta LIBRUS dostępna jest po jego powiązaniu
              z kontem w systemie Synergia. Szczegóły dostępne w
              <a
                href="/regulaminy"
                rel="noopener noreferrer"
                target="_blank"
                class="rules-link"
                >Regulaminie świadczenia usługi</a
              >
              i
              <a
                href="https://synergia.librus.pl/polityka-prywatnosci/"
                rel="noopener noreferrer"
                target="_blank"
                class="rules-link"
                >Polityce prywatności</a
              >.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import mobileAppFeatures from "../content/mobileAppFeatures.json";
import mobileAppVariants from "../content/mobileAppVariants.json";
import appConfigStore from "../config/appConfigStore";
import ShowPrice from "../components/price/md-price";
import CheckIcon from "../components/icons/CheckIcon";
import HelpIcon from "../components/icons/HelpIcon";
import MessageIcon from "../components/icons/MessageIcon";
import PeopleIcon from "../components/icons/PeopleIcon";
import KindergartenIcon from "../components/icons/KindergartenIcon";
import LibrusGoIcon from "../components/icons/LibrusGoIcon";
import TrophyIcon from "../components/icons/TrophyIcon";
import SinglePersonIcon from "../components/icons/SinglePersonIcon";
import ArrowBlue from "../components/icons/ArrowBlue";
import ArrowOrange from "../components/icons/ArrowOrange";
import getDynamicSchoolYear from "../assets/js/getDynamicSchoolYear";
import DescriptionTooltip from "./components/MobileFeatureHelpTooltip.vue";
import CalendarIcon from "../components/icons/CalendarIcon.vue";

export default {
  name: "AplikacjaMobilna",
  components: {
    "description-tooltip": DescriptionTooltip,
    CheckIcon,
    HelpIcon,
    KindergartenIcon,
    MessageIcon,
    CalendarIcon,
    PeopleIcon,
    TrophyIcon,
    ShowPrice,
    LibrusGoIcon,
    SinglePersonIcon,
    ArrowBlue,
    ArrowOrange,
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const fetchedPrice = await axios.get(
        `${appConfigStore.config.PORTAL_API}/md-web-price`,
      );
      next((vm) => vm.setData(false, fetchedPrice.data));
    } catch (e) {
      next((vm) => vm.setData(true, {}));
    }
  },
  data() {
    return {
      fetchedPrice: {},
      fetchedError: false,
      mobileAppFeatures,
      mobileAppVariants,
      currentSchoolYear: getDynamicSchoolYear(),
      currentYear: getDynamicSchoolYear(true),
    };
  },
  created() {
    this.$emit("showFaqHeader", false);
  },
  mounted() {
    document.title = "Aplikacja mobilna";
  },
  methods: {
    checkIfHasLongText(text) {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      context.font = getComputedStyle(document.body).font;

      return context.measureText(text).width;
    },
    getFeatureDescriptionByFeatureName(name) {
      const features = this.mobileAppVariants.map((item) => item.features);
      const joinedFeatures = features.flat();
      const featureTooltip = joinedFeatures.find((item) => item.name === name);

      return featureTooltip?.tooltip || "";
    },
    setData(fetchedError, fetchedPrice) {
      this.fetchedError = fetchedError;
      this.fetchedPrice = fetchedPrice;
    },
  },
};
</script>
<style scoped lang="scss">
.sticky {
  position: sticky;
  top: 80px;
}
.custom-size {
  width: 100%;
  max-width: 405px;
}
.kindergarten {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: url("../assets/images/kindergarten.png");
  background-repeat: no-repeat;
  padding: 50px 0 0;
}
.icon-box {
  display: block;
  background: white;
  padding: 40px 40px 0;
  margin-top: 20px;
  width: 90%;
  max-width: 1100px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
}
.icon-box__header {
  position: relative;
  text-align: center;
}
.icon-box__band {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #f76566;
  color: white;
  padding: 10px;
  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 100%;
    top: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 22px 0 22px 22px;
    border-color: transparent transparent transparent #f76566;
  }
  @media screen and (max-width: 767px) {
    position: static;
    max-width: 200px;
    margin: 0 auto;
    &:after {
      display: none;
    }
  }
}
.icon-box__main {
  margin-top: 40px;
  padding-bottom: 40px;
}
.icon-box__img {
  width: 100px;
  height: auto;
}
.md-item-remote {
  background-color: #f7f7f7;
}
.relative {
  position: relative;
}
@media screen and (max-width: 1200px) {
  .remote-title {
    width: 100%;
    height: auto;
    position: static;
  }
}
.md-variant {
  background-color: #f9f9f9;
}
.md-variant__head {
  border-bottom: 1px solid #7070701d;
}
.md-variant__name {
  font-weight: 600;
}
.md-variant__price {
  font-size: 2.625rem;
  font-weight: 600;
}
.md-variant__price-asterisk {
  font-size: 2.625rem;
  font-weight: 600;
}
.md-variant__tooltip {
  display: inline-block;
  margin-left: 8px;
  cursor: pointer;
}
.md-variant__feature {
  display: flex;
  align-items: flex-start;
}
.md-variant__feature span {
  font-size: 1rem;
}

.mobile-addons-title,
.mobile-addons-description {
  color: #fff;
}

.payment-mobile-app-badge {
  background-color: rgba(255, 255, 255, 0.12);
}
</style>
